import root from "window-or-global";

import {fetchAuthorized} from "@atg-shared/auth";
import atgRequest from "@atg-shared/fetch";
import {TEAM_SERVICE_PUBLIC_URL, TEAM_SERVICE_URL} from "@atg-shared/service-url";

import {
    mapFormData,
    mapToCreateFormData,
    uploadCreateTeam,
    uploadTeamImage,
} from "./teamUpload";

import type {CreateTeamPayload} from "../../domain/team.types";
import type {UploadableFile} from "@atg-ui/avatar";

export {mapFormData, mapToCreateFormData};

export const createTeam = (payload: CreateTeamPayload) => uploadCreateTeam(payload);

export const saveTeamImage = (teamId: string, file: UploadableFile) =>
    uploadTeamImage(teamId, file);

export const fetchTeamMembers = (teamId: string, isLoggedOut = false) =>
    root.location.pathname.includes("/utloggad/") || isLoggedOut
        ? atgRequest(`${TEAM_SERVICE_PUBLIC_URL}/${teamId}/members`, {
              method: "GET",
          })
        : fetchAuthorized(`${TEAM_SERVICE_URL}/${teamId}/members`, {
              method: "GET",
          });

export const revokeApplication = (applicationId: number) =>
    fetchAuthorized(`${TEAM_SERVICE_URL}/applications/${applicationId}`, {
        method: "DELETE",
    });

export const joinTeam = (teamId: number) =>
    atgRequest(`${TEAM_SERVICE_URL}/${teamId}/members`, {
        method: "POST",
    })
        .then((response) => response)
        .catch((error) => {
            if (error.response.meta.code === 409) {
                return error.response;
            }
            throw error;
        });

export const applyForTeam = (teamId: number, greeting: unknown) =>
    atgRequest(`${TEAM_SERVICE_URL}/${teamId}/applications`, {
        method: "POST",
        body: JSON.stringify({greeting}),
    })
        .then((response) => response)
        .catch((error) => {
            if (error.response.meta.code === 409) {
                return error.response;
            }
            throw error;
        });
